app.factory("FacebookService",
	function() {
		this.initialized = false;

		this.Initialize = function() {
			if(this.initialized) {
				return false;
			}
			window.fbAsyncInit = function () {
				FB.init({
					appId: '669074283182294',
					xfbml: true,
					version: 'v2.1'
				});
			};

			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) {
					return;
				}
				js = d.createElement(s);
				js.id = id;
				js.src = "//connect.facebook.net/en_US/sdk.js";
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));

			this.initialized = true;
		};

		this.Share = function(href, callback) {
			FB.ui({
				method: 'share',
				href: href
			}, function(response){
				if(callback) {
					callback(response);
				}
			});
		};

		return this;
	}
);